export default __webpack_public_path__ + "static/media/info.487fcb18.svg";